import { getPartnerDetails } from '../utils/helper'

const getConfigDetails = Object.freeze({
  ENV: process.env.REACT_APP_ENV,

  // Base URLs
  baseURL: process.env.REACT_APP_API_BASE_URL,
  FadminUrl: process.env.REACT_APP_ADMIN_URL,
  checkInUrl: process.env.REACT_APP_CHECKIN_URL,
  transientURL: process.env.REACT_APP_TRANSIENT_URL,
  portalURL: process.env.REACT_APP_PORTAL_URL,

  //rev admin
  revadminUrl: process.env.REACT_APP_REV_ADMIN_URL || null,
  revcheckInUrl: process.env.REACT_APP_REV_CHECKIN_URL || null,
  revtransientURL: process.env.REACT_APP_REV_TRANSIENT_URL || null,
  revcustomerPortalURL: process.env.REACT_APP_REV_CUSTOMERPORTAL_URL || null,
  revportalURL: process.env.REACT_APP_REV_CUSTOMERPORTAL_NAVIGATING_URL,

  pciAdminUrl: process.env.REACT_APP_PCI_ADMIN_URL || null,
  pciCheckInUrl: process.env.REACT_APP_PCI_CHECKIN_URL || null,
  pciTransientURL: process.env.REACT_APP_PCI_TRANSIENT_URL || null,
  pciPortalURL: process.env.REACT_APP_PCI_CUSTOMERPORTAL_URL || null,

  // Static IDs
  FULL_SEASON: process.env.REACT_APP_FULL_SEASON,
  HALF_SEASON: process.env.REACT_APP_HALF_SEASON,
  SIX_PACK: process.env.REACT_APP_SIX_PACK,
  FACILITY_ID: process.env.REACT_APP_FACILITY_ID,
  chiperKey: process.env.REACT_APP_CHIPER_KEY,
  recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,

  // Runtime (dynamic)
  get PARTNER_ID() {
    return getPartnerDetails()?.clients?.partner_id ?? null
  },

  get CLIENT_ID() {
    return getPartnerDetails()?.clients?.id ?? null
  },

  get CLIENT_SECRET() {
    return getPartnerDetails()?.clients?.secret ?? ''
  },

})

export default getConfigDetails
